// Models imports
import { SideNavMenuInfo } from '../_models/side-nav-menu-info';
import { isAmenityBookingEnabled } from './feature-flags';

export class SideNavigationMenus {
  static homeMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'home',
      'My Dashboard',
      '/home',
      'fa-solid fa-tachometer-alt',
      false
    )
  ];

  static paymentSubMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'account-statement',
      'Account Statement',
      '/accounts/statements'
    ),
    SideNavMenuInfo.create(
      'payment',
      'Make a Payment',
      '/accounts/payment-history',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'set-recurring-payment',
      'Set up Recurring Payments',
      '/accounts/set-recurring-payment'
    )
  ];
  static paymentMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'payments',
      'Payments',
      null,
      'fa-solid fa-credit-card',
      false,
      false,
      SideNavigationMenus.paymentSubMenuItems
    )
  ];

  static propertySubMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'workorders',
      'My Requests',
      '/accounts/workorders',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'compliance',
      'Compliance',
      '/accounts/compliance',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'account-info',
      'Property Info',
      '/accounts/information'
    ),
    SideNavMenuInfo.create(
      'account-info',
      'Owner Information',
      '/accounts/owner-information'
    ),
    SideNavMenuInfo.create(
      'account-info',
      'Contact Information',
      '/accounts/contact-information'
    ),
    SideNavMenuInfo.create(
      'account-info',
      'Directory Sharing',
      '/accounts/directory-sharing'
    ),
    SideNavMenuInfo.create(
      'architectural-application',
      'Architectural Requests',
      '/accounts/architectural-application',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'additional-info',
      'Additional Info',
      '/accounts/additional-info',
      undefined,
      false,
      true
    )
  ];
  static propertyMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'accounts',
      'My Property',
      null,
      'fa-solid fa-book',
      false,
      false,
      SideNavigationMenus.propertySubMenuItems
    )
  ];

  static communitySubMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'community-dashboard',
      'Community Dashboard',
      '/community/dashboard',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'community-info',
      'Community Information',
      '/community/information',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'legal-info',
      'Legal Information',
      '/community/legal-information'
    ),
    SideNavMenuInfo.create(
      'board-of-directors',
      'Board of Directors',
      '/community/board-of-directors',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'resident-directory',
      'Resident Directory',
      '/community/resident-directory',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'community-calendar',
      'Community Calendar',
      '/community/calendar'
    ),
    SideNavMenuInfo.create(
      'restriction-summary',
      'Rules & Restrictions',
      '/community/restrictions-summary',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create(
      'report-violation',
      'Report a Violation',
      '/community/report-violation',
      undefined,
      false,
      true
    ),
    SideNavMenuInfo.create('my-doc', 'Documents', '/accounts/documents'),
    SideNavMenuInfo.create(
      'meeting-hub',
      'Meeting Hub',
      '/community/meeting-hub',
      undefined,
      false,
      true,
      undefined,
      'New'
    ),
    SideNavMenuInfo.create(
      'order-media',
      'Access Media / Keys',
      '/accounts/order-access-media-keys',
      undefined,
      false,
      true
    ),
    ...(isAmenityBookingEnabled()
      ? [
          SideNavMenuInfo.create(
            'amenity-booking',
            'Reservations',
            '/community/amenity-booking'
          )
        ]
      : [])
  ];
  static communityMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'community',
      'My Community',
      null,
      'map',
      false,
      false,
      SideNavigationMenus.communitySubMenuItems
    )
  ];

  static topMenuItems: SideNavMenuInfo[] = [].concat(
    SideNavigationMenus.homeMenuItems,
    SideNavigationMenus.paymentMenuItems,
    SideNavigationMenus.propertyMenuItems,
    SideNavigationMenus.communityMenuItems
  );

  static bottomMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'contact-us',
      'Contact Us',
      '/contact-us',
      'fa-solid fa-address-book'
    ),
    SideNavMenuInfo.create('help', 'Help', null, 'fa-solid fa-question')
  ];

  static buttonMenuItems: SideNavMenuInfo[] = [
    SideNavMenuInfo.create(
      'one-time-payment',
      'Make a One-Time Payment',
      '/accounts/one-time-payment'
    ),
    SideNavMenuInfo.create(
      'set-recurring-payment',
      'Set up Recurring Payments',
      '/accounts/set-recurring-payment'
    )
  ];

  // Sub-routes not shown in the nav but registered so AccessGuard can resolve them.
  static hiddenRouteItems: SideNavMenuInfo[] = [
    ...(isAmenityBookingEnabled()
      ? [
          SideNavMenuInfo.create(
            'amenity-booking',
            'My Bookings',
            '/community/my-bookings'
          )
        ]
      : [])
  ];
}
